<template>
  <div class="room-tool-page" v-if="showTool">
    <div class="room-tool-dialog" ref="roomToolDialog">
      <div class="title">Room tools</div>
      <div class="op-panel">
        <div class="op-item recharge" @click.stop="toRecharge"></div>
        <div v-if="type==1" :class="'op-item dm '+(purOff?'off':'')" @click.stop="togglePureMode"></div>
        <div v-if="type==2&&selfBoss" :class="'op-item mic '+(bossMicOff?'off':'')"
             @click.stop="toggleMic(bossMicOff)"></div>
        <div v-if="type==2&&selfBoss" :class="'op-item camera '+(bossCameraOff?'off':'')"
             @click.stop="toggleCamera(bossCameraOff)"></div>
        <div v-if="type==2&&selfBoss" class="op-item flip" @click.stop="flip()"></div>

      </div>
    </div>
  </div>
</template>

<script>
  import StatisticsHelper from "../../utils/StatisticsUtils";

  export default {
    name: "roomtool",
    props: {
      type: 0, //1-live 2-mb 3-private
      selfBoss: false,
      showTool: false,
      purOff: false,
      bossMicOff: false,
      bossCameraOff: false,
      rechargeCallback: {
        type: Function,
        default: null
      },
      clearCallback: {
        type: Function,
        default: null
      },
      micCallback: {
        type: Function,
        default: null
      },
      cameraCallback: {
        type: Function,
        default: null
      },
      flipCallback: {
        type: Function,
        default: null
      },
    },
    methods: {
      togglePureMode() {
        this.clearCallback && this.clearCallback()
        this.hideRoomTool()
      },
      toRecharge() {
        StatisticsHelper.track_click_recharge(this.type)
        this.rechargeCallback && this.rechargeCallback()
        this.hideRoomTool()
      },
      toggleMic(curMicStatus) {
        this.micCallback && this.micCallback(curMicStatus)
        this.hideRoomTool()
      },
      toggleCamera(curCameraStatus) {
        this.cameraCallback && this.cameraCallback(curCameraStatus)
        this.hideRoomTool()
      },
      flip() {
        this.flipCallback && this.flipCallback()
        this.hideRoomTool()
      },
      hideRoomTool() {
        this.$emit('hideRoomTool')
      },
      bodyCloseRoomToolDialog(e) {
        let self = this;
        if (this.$refs.roomToolDialog && !this.$refs.roomToolDialog.contains(e.target)) {
          self.hideRoomTool();
        }
      },
    },
    watch: {
      showTool(n, o) {
        if (n){
          let target=this
          setTimeout(()=>{
            document.addEventListener('click', target.bodyCloseRoomToolDialog)
          },200)
        }else {
          document.removeEventListener('click', this.bodyCloseRoomToolDialog)
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .room-tool-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4;

    .room-tool-dialog {
      background: rgba(0, 0, 0, .8);
      .h(254);
      width: 100%;
      position: absolute;
      bottom: 0;
      .b-radius(40, 40, 0, 0);
      backdrop-filter: blur(.26rem);

      .title {
        text-align: left;
        .fs(28);
        font-family: Gilroy-Bold;
        color: #fff;
        .ml(32);
        .mt(32);
      }

      .op-panel {
        .mt(24);
        display: flex;
        flex-direction: row;

        .op-item {
          cursor: pointer;
          .w(120);
          .h(80);
          .ml(30);
        }

        .op-item:first-child {
          .ml(36);
        }

        .op-item.recharge {
          background: url(../../assets/imgs/roomtool/room-tool-recharge.png) no-repeat center;
          background-size: contain;
        }

        .op-item.recharge::after {
          content: 'Recharge';
          display: block;
          font-family: Gilroy-Medium;
          color: #aaabaf;
          text-align: center;
          .mt(85);
        }

        .op-item.dm {
          background: url(../../assets/imgs/roomtool/room-tool-pure-on.png) no-repeat center;
          background-size: contain;
        }

        .op-item.dm.off {
          background: url(../../assets/imgs/roomtool/room-tool-pure-off.png) no-repeat center;
          background-size: contain;
        }

        .op-item.dm::after {
          content: 'Pure mode';
          display: block;
          font-family: Gilroy-Medium;
          color: #aaabaf;
          text-align: center;
          .mt(85);
        }

        .op-item.mic {
          background: url(../../assets/imgs/roomtool/room-tool-mute-on.png) no-repeat center;
          background-size: contain;
        }

        .op-item.mic::after {
          content: 'Mute';
          display: block;
          font-family: Gilroy-Medium;
          color: #aaabaf;
          text-align: center;
          .mt(85);
        }

        .op-item.mic.off {
          background: url(../../assets/imgs/roomtool/room-tool-mute-off.png) no-repeat center;
          background-size: contain;
        }

        .op-item.camera {
          background: url(../../assets/imgs/roomtool/room-tool-camera-on.png) no-repeat center;
          background-size: contain;
        }

        .op-item.camera.off {
          background: url(../../assets/imgs/roomtool/room-tool-camera-off.png) no-repeat center;
          background-size: contain;
        }

        .op-item.camera::after {
          content: 'Camera';
          display: block;
          font-family: Gilroy-Medium;
          color: #aaabaf;
          text-align: center;
          .mt(85);
        }

        .op-item.flip {
          background: url(../../assets/imgs/roomtool/room-tool-flip.png) no-repeat center;
          background-size: contain;
        }

        .op-item.flip::after {
          content: 'Flip';
          display: block;
          font-family: Gilroy-Medium;
          color: #aaabaf;
          text-align: center;
          .mt(85);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/roomtool.vue